var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAttach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3864 9.98398L8.69305 12.6202C7.19915 14.0824 7.19915 16.4411 8.69305 17.9033C10.187 19.3655 12.5968 19.3655 14.0907 17.9033L18.3325 13.7515C21.3094 10.8378 21.3094 6.09903 18.3325 3.1853C15.3556 0.271568 10.5141 0.271568 7.53718 3.1853L2.91372 7.71063C0.362093 10.2081 0.362093 14.2639 2.91372 16.772",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAttach);
export default __webpack_public_path__ + "static/media/icon-attach.89ef6f2d81e06c45f3b0af7cd6fadf48.svg";
export { ForwardRef as ReactComponent };